import { useEffect, useState } from 'react';

/** Text for a live region that starts empty and fills after mount, so screen
 *  readers announce the first value as well as every later change. */
export function useLiveText(text: string): string {
  const [live, setLive] = useState('');
  useEffect(() => {
    const timer = setTimeout(() => setLive(text), 0);
    return () => clearTimeout(timer);
  }, [text]);
  return live;
}
